import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { getTableModeSwitcherStyles } from 'client/js/main/screens/ScreenRoiHub/styles';
import { ImageService } from 'client/js/main/services/ImageService/ImageService';
import { selectReportActiveMode, selectRoiAnalyticsReportTableState } from 'client/js/main/selectors/RoiHub';
import { useDispatch, useSelector } from 'client/js/redux';
import type { ReportActiveMode } from '../../types';
import { setPageState } from 'client/js/common/actions/ShareableActions';
import { ROI_ANALYTICS_NAMESPACE } from '../../../../../../../shared/constants';
import { ROI_ANALYTICS_TABLE } from '../../../../../../../shared/constants/analytics/contexts';
import { getLoadingState } from 'client/js/common/selectors/DruidSelectors';

const useTableModeSwitcherService = () => {
  const [isDisabled, setDisabled] = useState(false);
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const activeMode = useSelector(selectReportActiveMode);
  const reportTableState = useSelector(selectRoiAnalyticsReportTableState);
  const isDruidLoading = useSelector(getLoadingState);

  useEffect(() => {
    setDisabled(true);
  }, [activeMode]);

  useEffect(() => {
    if (!isDruidLoading) {
      setDisabled(false);
    }
  }, [isDruidLoading]);

  const iconPath = ImageService.getImageUrl('/static/images/roi-hub/tree-view-icon.svg');

  const css = getTableModeSwitcherStyles(activeMode, iconPath, isDisabled);

  const updateActiveMode = (updatedActiveMode: ReportActiveMode) => {
    const data = { [ROI_ANALYTICS_TABLE]: { ...reportTableState, activeMode: updatedActiveMode } };
    dispatch(setPageState(ROI_ANALYTICS_NAMESPACE, data));
  };

  const onTreeButtonClick = () => {
    updateActiveMode('tree');
  };

  const onFlatButtonClick = () => {
    updateActiveMode('flat');
  };

  return {
    isOnRoiAnalytics: pathname === '/ads/roi-hub/analytics',
    css,
    onTreeButtonClick,
    onFlatButtonClick,
    activeMode,
    disabled: isDisabled,
  };
};

export default useTableModeSwitcherService;
